import * as tslib_1 from "tslib";
import { AfterViewInit, ViewContainerRef } from '@angular/core';
import { BaseComponent } from '../../base.component';
//import { MapCatalogComponent } from '../map-catalog/map-catalog.component';
var MergeMapActionComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MergeMapActionComponent, _super);
    function MergeMapActionComponent(_vcr) {
        return _super.call(this, _vcr, true) || this;
    }
    MergeMapActionComponent.prototype.ngAfterViewInit = function () {
        this.isReady();
    };
    MergeMapActionComponent.prototype.mergeMap = function () {
        var win = window.document.getElementById('mapCatalogWindow');
        if (win) {
            var mapCatalog = win.firstElementChild; // as MapCatalogComponent; // todo TFS#13854
            mapCatalog.mergeMaps = true;
            win.open();
        }
    };
    return MergeMapActionComponent;
}(BaseComponent));
export { MergeMapActionComponent };
